var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 89,
    viewBox: "0 0 1440 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5C67.1794 20.7213 135.11 41.861 206.08 40.5985C274.72 39.3803 342.88 16.4379 411.52 18.0621C480 19.7879 548.8 46.1818 617.28 54.303C685.92 62.4242 754.08 52.2727 822.72 45.1667C891.2 38.0606 960 34 1028.48 44.3546C1097.12 54.6076 1165.28 79.3773 1233.92 82.4227C1304.5 85.5615 1372.61 66.5081 1440 48.2121V88.5C960 88.5 480 88.5 0 88.5V0.5Z",
    fill: "#28293E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWave);
export default __webpack_public_path__ + "static/media/blue-wave.e5b23a6dddc522722a36a9bcee28a3d1.svg";
export { ForwardRef as ReactComponent };